import React from "react"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'


class SettingMenuItem extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div
        className="settingMenuItem"
        onClick={() => this.props.onClick()}>
        <h4>{this.props.title}</h4>
        <FontAwesomeIcon
          icon={faArrowRight}
          className="lightBlue"
          style={{fontSize: 16, marginRight: 10}}
        />
      </div>
    )
  }

}

export default SettingMenuItem;
